<button data-test="B-Zurück" mat-flat-button
        color="accent" class="mr-16" u2bBrowserBackOnClick>
    <mat-icon>arrow_back</mat-icon>
    <span fxHide.lt-sm>Zurück</span>
</button>
